module.exports = __webpack_public_path__ + "static/media/img18.afbbafdc.jpg";